export default __webpack_public_path__ + "static/media/Mark-6-HUD-Flight Indicator.94e7ae38.jpg";